/* eslint-disable no-mixed-spaces-and-tabs */
import { ElAvatar, ElCollapse, ElCollapseItem, ElIcon, randomCode } from '@qsxy/element-plus-react';
import classNames from 'classnames';

import 'katex/dist/katex.min.css';
import 'github-markdown-css';
import { useMarkdown } from '@/hooks/useMarkdown';
import { useMemo } from 'react';

type Props = {
	/** 消息内容 */
	content: string;
	/** 是否为用户消息 */
	isUser?: boolean;
	thinkingTime?: number;
	id?: string;
};

/** 消息气泡组件 */
const MessageBubble = (props: Props) => {
	const { content = '', isUser, thinkingTime, id = randomCode(11) } = props;

	const { renderMd } = useMarkdown();

	const messages = useMemo(() => (!isUser ? renderMd(content) : { think: null, content: null }), [content, isUser, renderMd]);

	// 格式化时间方法
	// const formatTime = () => {
	// 	const now = new Date();
	// 	return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
	// };

	return (
		<div className={classNames('ttn-message', isUser ? 'ttn-message-user' : 'ttn-message-ai')}>
			<div className="message-content">
				{/* 头像区域 */}
				<div className="avatar-wrapper">
					<ElAvatar size={40} className={isUser ? 'user-avatar' : 'ai-avatar'} src="undefined">
						{isUser ? <ElIcon prefix="fas" name="user" /> : <img src={require('@/assets/images/avatar.png')} />}
					</ElAvatar>
				</div>
				{/* 消息内容区域 */}
				<div className="bubble-wrapper">
					{/* {renderMd('***你好***')} */}
					<div className={classNames('bubble', { 'is-assistant': !isUser })}>
						{isUser ? <div className="user-self">你</div> : ''}
						{isUser ? (
							content
						) : (
							<>
								{messages.think ? (
									<ElCollapse defaultActiveName={[id]} style={{ '--el-collapse-header-height': '32px' }}>
										<ElCollapseItem
											title={
												<span>
													{messages.content ? '已深度思考' : '思考中'}
													{!messages.content && thinkingTime > 0 ? `(用时${thinkingTime}秒)` : ''}
												</span>
											}
											name={id}
										>
											<div className="message-text" dangerouslySetInnerHTML={{ __html: messages.think }}></div>
										</ElCollapseItem>
									</ElCollapse>
								) : null}

								{messages.content ? (
									<div className="message-text" dangerouslySetInnerHTML={{ __html: messages.content }}></div>
								) : (
									<ElIcon prefix="far" name="spinner-third" spin />
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MessageBubble;
